// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"s":"s","m":"m"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

const _map$1 = {"default":"default","white":"white"};

function kindToJs(param) {
  return param;
}

function kindFromJs(param) {
  return _map$1[param];
}

function LoadingSpinner(Props) {
  let sizeOpt = Props.size;
  let kindOpt = Props.kind;
  let className = Props.className;
  const size = sizeOpt !== undefined ? sizeOpt : "m";
  const kind = kindOpt !== undefined ? kindOpt : "default";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      className: Cn.fromList({
        hd: "loadingspinner",
        tl: {
          hd: size === "s" ? "w-4 h-4 border-2" : "w-8 h-8 border-4",
          tl: {
            hd: kind === "default" ? "border-gray-300 text-blue-500" : "border-transparent text-white",
            tl: {
              hd: Cn.take(className),
              tl: /* [] */ 0
            }
          }
        }
      })
    }),
    className: "h-full w-full flex justify-center items-center"
  });
}

const make = LoadingSpinner;

export {
  sizeToJs,
  sizeFromJs,
  kindToJs,
  kindFromJs,
  make,
}
/* react/jsx-runtime Not a pure module */
